import { useCallback } from 'react'
import { ToolBarButton } from 'components/ToolBarButton'
import useAnalytics from 'hooks/useAnalytics'
import LogModal from 'modals/LogModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { AlignLeft } from 'react-feather'
import { PV1Events } from 'services/analytics/events/pv1Events'
import type { SideToolBarProps } from 'types'

export const LogButton = ({ logs, fillId, orderId }: Partial<SideToolBarProps>) => {
  const { showModal } = useModalContext()
  const { trackPV1Event } = useAnalytics()

  const showLog = useCallback(() => {
    trackPV1Event(PV1Events.PV1_LOG_CLICK.key, {
      fillId,
    })
    showModal(() => <LogModal orderId={orderId} fillId={fillId} logs={logs} />)
  }, [fillId, orderId, logs, showModal, trackPV1Event])

  return <ToolBarButton label="LOG" icon={AlignLeft} tooltipText="LOG" clickCallback={showLog} />
}
